module.exports = __webpack_public_path__ + "static/media/footer_desktop@2x.174ae1b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planning/footer_desktop@2x.jpg
// module id = 1516
// module chunks = 40